import { render, staticRenderFns } from "./JobStatus.vue?vue&type=template&id=180badf7&scoped=true&"
import script from "./JobStatus.vue?vue&type=script&lang=js&"
export * from "./JobStatus.vue?vue&type=script&lang=js&"
import style0 from "./JobStatus.vue?vue&type=style&index=0&id=180badf7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180badf7",
  null
  
)

export default component.exports